import React, { Component } from 'react';

class NotFound extends Component {
  constructor() {
    super();
  }
  componentDidMount() {}

  render() {
    return (
      <div>
        <h1>404 page</h1>
      </div>
    );
  }
}

export default NotFound;
